import { useToastStore } from "@/stores/modules/toast/toast";
import type { ToastOptions } from "@/types/toast";
import type { ToastParams } from "@/types/notification";

export function setWarningToast({
  message = "",
  title,
  emoji = "⚠️",
  timeout = 3000,
  click = () => {},
}: ToastParams) {
  const toastStore = useToastStore();
  toastStore.addToast("warning", {
    message,
    title,
    emoji,
    timeout,
    click,
  });
}

export function setInfoToast({
  message = "",
  title,
  emoji = "ℹ️",
  timeout = 3000,
  click = () => {},
}: ToastParams) {
  const toastStore = useToastStore();
  toastStore.addToast("info", {
    message,
    title,
    emoji,
    timeout,
    click,
  });
}

export function setSuccessToast({
  message = "",
  title,
  emoji = "✅",
  timeout = 3000,
  click = () => {},
}: ToastParams) {
  const toastStore = useToastStore();
  toastStore.addToast("success", {
    message,
    title,
    emoji,
    timeout,
    click,
  });
}

export function setErrorToast({
  message = "",
  title,
  emoji = "❌",
  timeout = 6000,
  click = () => {},
}: ToastParams) {
  const toastStore = useToastStore();
  toastStore.addToast("error", {
    message,
    title,
    emoji,
    timeout,
    click,
  });
}

// Generic toast function for full control
export function setToast(
  type: "success" | "info" | "warning" | "error",
  options: ToastOptions,
) {
  const toastStore = useToastStore();
  toastStore.addToast(type, options);
}
